import type { MxpModuleIdV2 } from './mxp365-v2.types';

// Reverse of the v1 MXP_MODULE_PATHS map (apps/dashboard/src/modules/prism/lib/mxp365/paths.ts).
// Only includes paths whose v1 module ID has a direct v2 equivalent.
// Paths with no v2 counterpart (e.g. /activities/tours/itinerary → mxp365-itinerary) are
// intentionally omitted so those tiles fall back to the v1 dialog.
const PATH_TO_MODULE_V2: Readonly<Record<string, MxpModuleIdV2>> = {
  '/activities/tours/shore-excursions': 'mxp365-shorex',
  '/itinerary': 'mxp365-port-info',
  '/my-calendar': 'mxp365-my-calendar',
  '/activities/dailyevents/board-activities': 'mxp365-board-activities',
  '/activities/spa/spa': 'mxp365-spa',
  '/activities/spa/fitness': 'mxp365-fitness',
  '/activities/spa/hair-dresser': 'mxp365-hair-dresser',
  '/activities/spa/permanent-makeup-parent': 'mxp365-makeup',
  '/restaurants': 'mxp365-restaurants',
  '/packages': 'mxp365-packages',
  '/venues': 'mxp365-venues',
  '/deck-plan': 'mxp365-deck-plan',
  '/opening-hours': 'mxp365-opening-hours',
  '/announcements': 'mxp365-announcements',
  '/weather': 'mxp365-weather',
  '/favorites': 'mxp365-favorites',
  '/chat': 'mxp365-chat',
  '/messages': 'mxp365-messages',
};

export const pathToModuleV2 = (path: string): MxpModuleIdV2 | undefined =>
  PATH_TO_MODULE_V2[path];
